// extracted by mini-css-extract-plugin
module.exports = {"surfCams":"SurfCams_surfCams__d472Y"};